/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/



// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import { Grid } from "@mui/material";


// Soft UI Dashboard PRO React example components

// SmartHome dashboard components

// Data


//Backend access
import { useQuery } from '@tanstack/react-query';
import { getProcessedImage, loadToken } from '../../api/crowd_counting';
import PropTypes from "prop-types";



import { useAuth0 } from "@auth0/auth0-react";

// Images



function CameraImageProcessed({ image_data }) {

  loadToken(useAuth0());
  // console.log(image_data)
  // debugger;
  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ['getProcessedImage', image_data._id],
    queryFn: async () => {
      const data = await getProcessedImage(image_data._id);
      return data;
    },
    staleTime: Infinity,
  });

  if (isLoading) {
    return "Loading...";
  }

  if (error) {
    return "Error! " + error.message;
  }

  const blob = new Blob([data], { type: 'image/png' });
  const url = URL.createObjectURL(blob);


  // debugger;
  return (
    <SoftBox sx={{ height: "100%" }}>
      <Grid container sx={{ height: "100%" }}>
        <Grid item xxs={12} sm={12} md={12} lg={12} xl={12} sx={{ height: "100%" }}>
          <SoftBox sx={{ 'object-fit': "contain", textAlign: 'center', height: "100%", width: "100%" }} >
            <SoftBox
              component="img"
              src={url}
              position="relative"
              maxWidth="100%"
              height="100%"
              borderRadius="lg"
            />
          </SoftBox>
        </Grid>
      </Grid>
    </SoftBox>
  );
}

// Typechecking props for the CameraImage
CameraImageProcessed.propTypes = {
  image_data: PropTypes.object
};


export default CameraImageProcessed;
